<div class="logo" (mouseenter)="onLogoMouseEnter()">
  <div class="logo__animation" aria-hidden="true">
    <brt-lottie (instanceCreated)="onLogoAnimCreated($event)"
                [lottieOptions]="animationOptions"></brt-lottie>
  </div>

  <img class="logo__image" src="/assets/img/berufsreise-at-logo-red.svg" alt="Logo Berufsreise.at">
</div>
